import React, { useEffect, useState } from "react";
import { ButtonHLPure, InputHLPure, TextAreaHLPure, Traslates, DataPickerHLPure } from "../../pures";
import { Container, Grid } from '@material-ui/core'
import './procedure-administration-edit-new.css';

const ProcedureAdministrationEditNew = (props) => {

    let {
        t,
        handleShowPrincipalView,
        viewSelected,
        procedureSelectedGrid,
        toggleLoadingRequesting,
        toggleErrorRequesting,
        createProcedure
    } = props

    const [procedureName, setProcedureName] = useState('')
    const [entity, setEntity] = useState('')
    const [dateStart, setDateStart] = useState('')
    const [finishDate, setFinishDate] = useState('')

    useEffect(() => {
        if(!viewSelected || viewSelected !== t("procedureAdministrationView.details") || !procedureSelectedGrid || !procedureSelectedGrid.name) return
        let name = procedureSelectedGrid.name || ''
        let entity = procedureSelectedGrid.entity || ''
        let dateConvert = (procedureSelectedGrid && procedureSelectedGrid.startDate) ? new Date(procedureSelectedGrid.startDate) : ''
        let startDate = (dateConvert && !isNaN(dateConvert)) ? dateConvert : ''
        let dateConvertFinish = (procedureSelectedGrid && procedureSelectedGrid.finishDate) ? new Date(procedureSelectedGrid.finishDate) : ''
        let finishDate = (dateConvertFinish && !isNaN(dateConvertFinish)) ? dateConvertFinish : ''
        
        setProcedureName(name)
        setEntity(entity)
        setDateStart(startDate)
        setFinishDate(finishDate)
    }, [viewSelected, procedureSelectedGrid])

    const onHandleChange = (e, setValue) => {
        let value = e.target.value
        setValue(value)
    }

    const saveData = () => {
        toggleLoadingRequesting(true)
        if(!procedureName){
            let messageError = 'Agregar un nombre al trámite'
            toggleLoadingRequesting(false)
            toggleErrorRequesting(messageError, 4000, false, '/')
            return
        }

        //Crear la lógica para agregar el procedureUserId y el statusApplicationTypeId
        let data = {
            nameProcedure: procedureName, 
            procedureUserId: 49, 
            statusApplicationTypeId: 38, 
            startDate: dateStart, 
            limitDate: finishDate
        }

        if(viewSelected === t("procedureAdministrationView.details")){
            console.log('Se actualizó el trámite')
            toggleLoadingRequesting(false)
        }else{
            createProcedure(data, handleShowPrincipalView, handleCleanInputs)
        }
    }

    const handleCleanInputs = () => {
        setProcedureName('')
        setEntity('')
        setDateStart('')
        setFinishDate('')
    }

    return(
        <Container>
            <Grid                 
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
            >
                <div className="procedureAdministrationEditNew-body">
                    <div className="procedureAdministrationEditNew-container-data">
                        <div className="procedureAdministrationEditNew-container-left">
                            <InputHLPure
                                labelInput={t("procedureAdministrationEditNew-name-procedure")}
                                valueInput={procedureName}
                                typeInput={"text"}
                                required
                                handleChangeInput={(e) => onHandleChange(e, setProcedureName)}
                                inputActive
                            />
                            <InputHLPure
                                labelInput={t("procedureAdministrationEditNew-entity")}
                                valueInput={entity}
                                typeInput={"text"}
                                handleChangeInput={(e) => onHandleChange(e, setEntity)}
                                inputActive
                            />
                        </div>
                        <div className="procedureAdministrationEditNew-container-right">
                            <Traslates>
                                <DataPickerHLPure
                                    labelDataPicker={t("procedureAdministrationEditNew-start-date")}
                                    valueDate={dateStart}
                                    handleChangeDate={(e) => onHandleChange(e, setDateStart)}
                                    formatPicker={'dd/MM/yyyy'}
                                />
                            </Traslates>
                            <Traslates>
                                <DataPickerHLPure
                                    labelDataPicker={t("procedureAdministrationEditNew-finish-date")}
                                    valueDate={finishDate}
                                    handleChangeDate={(e) => onHandleChange(e, setFinishDate)}
                                    formatPicker={'dd/MM/yyyy'}
                                />
                            </Traslates>
                        </div>
                    </div>
                    <div className="procedureAdministrationEditNew-container-btns">
                        <div className="procedureAdministrationEditNew-btn-secundary">
                            <ButtonHLPure 
                                nameBtn={t("button.return")}
                                onClickBtn={handleShowPrincipalView}
                            />
                        </div>
                        <ButtonHLPure 
                            nameBtn={t("button.save")}
                            primary={true}
                            onClickBtn={() => saveData()}
                        />
                    </div>
                </div>
            </Grid>
        </Container>
    )
}

export { ProcedureAdministrationEditNew as default }